export enum AutoFeederAction {
    NEXT = 'Next',
    CLOSE = 'Close',
    QUICK_TO_OLD = 'QuickToOld'
}
